import { createRoute } from '@tanstack/react-router';
import { Route as appRoute } from '../app.js';
import { useAuth } from '../../hooks/useAuth.js';
import { useCategories } from '../../hooks/useCategories.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: Dashboard,
});

function Dashboard() {
  const { user } = useAuth();
  const { data } = useCategories();
  const firstName = user?.fullName.split(' ')[0] ?? 'there';

  return (
    <div className="max-w-3xl">
      <div className="mb-2 text-xs uppercase tracking-[0.14em] text-muted font-semibold">
        Admitly
      </div>
      <h1 className="font-serif text-5xl tracking-tighter2 mb-3">
        Welcome back, <span className="italic text-navy">{firstName}.</span>
      </h1>
      <p className="text-muted text-base leading-relaxed max-w-xl mb-10">
        Your course catalogue is live. Browse it from the sidebar, or start with{' '}
        <strong className="text-ink-soft font-semibold">Find courses</strong>.
      </p>

      <div className="surface p-6 space-y-4">
        <div className="flex items-baseline justify-between">
          <h2 className="font-serif text-xl tracking-tightish">What you can do here</h2>
          <span className="badge bg-success-bg text-success">Live</span>
        </div>
        <ul className="text-sm text-ink-soft space-y-2 leading-relaxed">
          <li className="flex gap-2">
            <span className="text-gold mt-0.5">✓</span>
            Search and browse the course catalogue by category and sub-category
            {data && <span className="text-muted"> · {data.categories.length} categories</span>}
          </li>
          <li className="flex gap-2">
            <span className="text-gold mt-0.5">✓</span>
            Shortlist courses and compare them side by side
          </li>
          <li className="flex gap-2">
            <span className="text-gold mt-0.5">✓</span>
            Email a course overview or application checklist as a branded PDF
          </li>
          <li className="flex gap-2">
            <span className="text-gold mt-0.5">✓</span>
            Build quotes from course fees and scholarships, where your access allows
          </li>
        </ul>
      </div>

      <div className="mt-6 surface-soft p-6">
        <h3 className="font-serif text-lg tracking-tightish mb-2">Not seeing something?</h3>
        <p className="text-sm text-muted leading-relaxed">
          The sidebar only shows what your role and permissions allow. Ask your
          agency admin if you need access to pricing, quotes, or admin tools.
        </p>
      </div>
    </div>
  );
}
